module.exports = __webpack_public_path__ + "img/czsc_11.220be75f.png";